/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Where_QuestionInputs */

const en_faq_where_question = /** @type {(inputs: Faq_Where_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who do you work with, and where?`)
};

const lv_faq_where_question = /** @type {(inputs: Faq_Where_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko un kur Jūs strādājat?`)
};

/**
* | output |
* | --- |
* | "Who do you work with, and where?" |
*
* @param {Faq_Where_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_where_question = /** @type {((inputs?: Faq_Where_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Where_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_where_question(inputs)
	return en_faq_where_question(inputs)
});